var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1693_2017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 150,
    height: 150,
    rx: 75,
    fill: "black",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8128 44.0308C102.561 47.1987 107.561 51.6561 110.965 57.2632C115.801 65.2286 117.64 74.6564 116.151 83.8551C114.663 93.0537 109.946 101.421 102.845 107.455C95.7448 113.49 86.7263 116.796 77.4081 116.781C68.0898 116.766 59.0819 113.431 52.0007 107.374C44.9194 101.318 40.2284 92.9355 38.7695 83.7322C37.3105 74.5289 39.1791 65.1069 44.0399 57.157C47.2778 51.8614 51.9687 47.6162 57.3579 44.5159C60.0592 42.9618 62.936 41.6954 65.8931 40.7285L61.6185 49.634C55.919 53.3743 54.4342 54.7057 50.5149 61.1159C46.5955 67.5261 45.0889 75.1232 46.2652 82.5439C47.4416 89.9647 51.224 96.7233 56.9337 101.607C62.6435 106.491 69.9067 109.18 77.4201 109.192C84.9335 109.204 92.2053 106.538 97.9305 101.672C103.656 96.8066 107.46 90.06 108.659 82.643C109.859 75.226 108.377 67.6242 104.478 61.2016C100.512 55.3372 98.8593 54.2076 93.4679 50.5215C93.1369 50.2952 92.7919 50.0593 92.4314 49.8121L89.2254 40.7285C91.8449 41.5942 94.395 42.6985 96.8128 44.0308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 77.4181C32 75.4508 33.5948 73.856 35.5622 73.856H49.8109C51.7783 73.856 53.3731 75.4508 53.3731 77.4181V77.7744C53.3731 79.7417 51.7783 81.3365 49.8109 81.3365H35.5622C33.5948 81.3365 32 79.7417 32 77.7744V77.4181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3292 123.387C75.3619 123.395 73.7602 121.808 73.7517 119.84L73.6903 105.592C73.6818 103.624 75.2697 102.023 77.237 102.014L77.5933 102.013C79.5606 102.004 81.1623 103.592 81.1708 105.559L81.2322 119.808C81.2407 121.775 79.6528 123.377 77.6855 123.385L77.3292 123.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.82 77.4181C101.82 75.4508 103.415 73.856 105.382 73.856H119.631C121.598 73.856 123.193 75.4508 123.193 77.4181V77.7744C123.193 79.7417 121.598 81.3365 119.631 81.3365H105.382C103.415 81.3365 101.82 79.7417 101.82 77.7744V77.4181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5988 32L59.9659 70.8278L77.2425 62.4567L95.4097 70.8278L77.5988 32Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1693_2017",
    x: -11,
    y: -11,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1693_2017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1693_2017",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetInactive);
export default __webpack_public_path__ + "static/media/resetInactive.880291d48f8d29cbb75d2f3dd7d1a95b.svg";
export { ForwardRef as ReactComponent };